import { IFieldSpecs } from "../../../../module/formbuilder/fields/interfaces/field-specs";
import { WORDING } from "./wording";
import { FormGroup } from "@angular/forms";

const validators = {};

export function getValidators (formControlName: string) {
    if (validators.hasOwnProperty(formControlName)) {
        return validators[formControlName];
    }
}

export function getFieldConfig (label: string, formControlName: string, group: FormGroup): IFieldSpecs {
    return {
        formGroup: group,
        label: WORDING[label],
        formControlName,
        validators: getValidators(formControlName)
    };
}